import type { CopyToClipboardPayload, ExportTextPayload, SharePayload } from '@publicala/delfino';
import { hostBridge } from '@publicala/delfino';
import { isE2EMockActive } from '../e2eMockGuard';

/**
 * UI API for Volpe.
 * Provides methods for UI actions via hostBridge.
 */
class UIAPI {
    /**
     * Close the reader.
     * Skipped in E2E standalone mode to prevent errors when hostBridge is not initialized.
     */
    async close(): Promise<void> {
        if (isE2EMockActive()) {
            return;
        }
        return hostBridge.ui.close();
    }

    /**
     * Open the login form.
     * Skipped in E2E standalone mode to prevent errors when hostBridge is not initialized.
     */
    async openLoginForm(): Promise<void> {
        if (isE2EMockActive()) {
            return;
        }
        return hostBridge.ui.openLoginForm();
    }

    /**
     * Toggle payment links modal.
     * Skipped in E2E standalone mode to prevent errors when hostBridge is not initialized.
     */
    async togglePaymentLinks(): Promise<void> {
        if (isE2EMockActive()) {
            return;
        }
        return hostBridge.ui.togglePaymentLinks();
    }

    /**
     * Share content via the host's share mechanism.
     * Skipped in E2E standalone mode to prevent errors when hostBridge is not initialized.
     */
    async shareContent(payload: SharePayload): Promise<void> {
        if (isE2EMockActive()) {
            return;
        }
        return hostBridge.ui.share(payload);
    }

    /**
     * Copy text to clipboard.
     * Skipped in E2E standalone mode to prevent errors when hostBridge is not initialized.
     */
    async copyToClipboard(payload: CopyToClipboardPayload): Promise<void> {
        if (isE2EMockActive()) {
            return;
        }
        return hostBridge.ui.copyToClipboard(payload);
    }

    /**
     * Export text to a file.
     * Skipped in E2E standalone mode to prevent errors when hostBridge is not initialized.
     * @param payload - Contains text and fileName
     */
    async exportText(payload: ExportTextPayload): Promise<void> {
        if (isE2EMockActive()) {
            return;
        }
        return hostBridge.ui.exportText(payload);
    }
}

export const uiAPI = new UIAPI();
